import { createSlice } from '@reduxjs/toolkit';
var initialState = {
  version: 'current',
  themeDataAttr: 'current'
};
export var osuiCssVarsSlice = createSlice({
  name: 'osuiCssVars',
  initialState: initialState,
  reducers: {
    setOSUICssVersion: function setOSUICssVersion(state, action) {
      state.version = action.payload;
    },
    setState: function setState(state, action) {
      Object.keys(action.payload).forEach(function (key) {
        // @ts-expect-error
        var val = action.payload[key]; // @ts-expect-error

        state[key] = val;
      });
    }
  }
});
//# sourceMappingURL=es/loadOSUICssVars/reduxSlice.js.map